import type { Sprint } from '@shared/schemas';

/** 19-sprint course metadata. Phase 1 ships full metadata · S01-S03 with content tickets. */
export const SPRINTS: ReadonlyArray<Sprint> = [
  {
    id: 'S01',
    ord: 1,
    block: 'manual',
    category: 'Mindset',
    title: 'Первый день в Артели — вход в профессию',
    goal:
      'Поймёшь, что такое тестирование и почему за него платят, научишься смотреть на продукт как тестировщик и найдёшь первые баги в Артели.',
    estimateMin: 112,
    ticketIds: ['T00', 'MS-00', 'MS-01', 'MS-02', 'MS-HUNT', 'MS-03', 'MS-SPHERES', 'MS-CAREER', 'MS-13', 'MS-14'],
    finalTestBankId: 'sprint-01',
    istqb: ['CTFL-Ch1'],
  },
  {
    id: 'S02',
    ord: 2,
    block: 'manual',
    category: 'Requirements',
    title: 'Requirements Reading — читаем ТЗ как QA',
    goal:
      'Научишься читать требования критически: видеть дыры, неоднозначности, missing AC. INVEST + Static testing + RTM.',
    estimateMin: 110,
    ticketIds: ['REQ-01', 'TEAM-01', 'REQ-03', 'REQ-04', 'REQ-05', 'REQ-06', 'REQ-07', 'REQ-08', 'REQ-09', 'REQ-10', 'REQ-11', 'REQ-12', 'REQ-14'],
    finalTestBankId: 'sprint-02',
    istqb: ['CTFL-Ch1', 'CTFL-Ch3'],
  },
  {
    id: 'S03',
    ord: 3,
    block: 'manual',
    category: 'Testing Types',
    title: 'Testing Plains — виды тестирования',
    goal:
      'Уровни и виды тестирования · exploratory по чартеру · атрибуты качества · приоритизация по риску.',
    estimateMin: 183,
    ticketIds: ['DOC-S3-01', 'DOC-S3-02', 'DOC-S3-02B', 'DOC-S3-03', 'DOC-S3-04', 'DOC-S3-04B', 'DOC-S3-05', 'DOC-S3-06', 'DOC-S3-06B', 'DOC-S3-07', 'DOC-S3-08', 'DOC-S3-09'],
    finalTestBankId: 'sprint-03',
    istqb: ['CTFL-Ch2', 'CTFL-Ch3'],
  },
  {
    id: 'S04',
    ord: 4,
    block: 'manual',
    category: 'Test Documentation',
    title: 'Document Heights — тестовая документация',
    goal: 'Test Scenario · Test Case · Use Case · Bug Report · Test Plan — артефакты, которые читает команда.',
    estimateMin: 184,
    ticketIds: ['TD-01', 'TD-02', 'TD-03', 'TD-04', 'TD-05', 'TD-06', 'TD-07', 'TD-08', 'TD-09', 'TD-10', 'TD-11'],
    finalTestBankId: 'sprint-04',
    istqb: ['CTFL-Ch4', 'CTFL-Ch5'],
  },
  {
    id: 'S05',
    ord: 5,
    block: 'manual',
    category: 'Test Design',
    title: 'Design Vista — тест-дизайн и метрики',
    goal: 'EP · BVA · Decision Table · State Transition · Pairwise · метрики прогона и GO/NO-GO.',
    estimateMin: 190,
    ticketIds: ['MGT-01', 'MGT-02', 'MGT-03', 'MGT-04', 'MGT-05', 'MGT-06', 'MGT-07', 'MGT-08', 'MGT-09', 'MGT-10', 'MGT-11'],
    finalTestBankId: 'sprint-05',
    istqb: ['CTFL-Ch4', 'CTFL-Ch5'],
  },
  {
    id: 'S06',
    ord: 6,
    block: 'manual',
    category: 'CTFL Foundation',
    title: 'CTFL Summit — финальная подготовка к экзамену',
    goal: 'Mock exam · Glossary 155 · Voucher · Release v0.5 unlock.',
    estimateMin: 180,
    ticketIds: ['CTFL-01', 'CTFL-02', 'CTFL-03', 'CTFL-04', 'CTFL-05', 'CTFL-06'],
    istqb: ['CTFL-Ch1', 'CTFL-Ch2', 'CTFL-Ch3', 'CTFL-Ch4', 'CTFL-Ch5', 'CTFL-Ch6'],
    release: 'v0.5',
    examSprint: true,
    optional: true,
  },
  // S07 · Bug Lifecycle / Reporting (Phase 3.4a · BLOCK2_TEXTBOOK_WRITER · 10 tickets)
  {
    id: 'S07',
    ord: 7,
    block: 'technical',
    category: 'Bug Lifecycle',
    title: 'Bug Lifecycle / Reporting',
    goal:
      'От находки бага до его закрытия: 6 lifecycle states + 5 edge · severity vs priority matrix · triage · tracker workflow (Linear) · evidence · senior patterns · AI-bug-helper.',
    estimateMin: 165,
    ticketIds: ['BUG-01', 'BUG-02', 'BUG-03', 'BUG-04', 'BUG-05', 'BUG-06', 'BUG-07', 'BUG-08', 'BUG-09', 'BUG-10'],
    finalTestBankId: 'sprint-07',
    istqb: ['CTFL-Ch5'],
  },
  // S08 · SQL для тестировщиков (Phase 3.4a · BLOCK2_TEXTBOOK_WRITER · 10 tickets · Block 2 anchor)
  {
    id: 'S08',
    ord: 8,
    block: 'technical',
    category: 'SQL',
    title: 'SQL для тестировщиков',
    goal:
      'Перестать быть QA, видящим только UI · спрашивать у БД напрямую. SELECT · WHERE · JOIN · GROUP BY · валидация миграций · investigation pattern · AI-bug-helper.',
    estimateMin: 165,
    ticketIds: ['SQL-01', 'SQL-02', 'SQL-03', 'SQL-04', 'SQL-05', 'SQL-06', 'SQL-07', 'SQL-08', 'SQL-09', 'SQL-10', 'SQL-11'],
    finalTestBankId: 'sprint-08',
    istqb: ['CTFL-Ch4'],
  },
  // S09 · HTTP & API (canonical 7 MAY · ticketIds wire в 3.4b после writer slot)
  {
    id: 'S09',
    ord: 9,
    block: 'technical',
    category: 'HTTP & API',
    title: 'HTTP & API testing — REST глазами QA',
    goal:
      'HTTP-методы · status codes · headers · JSON · REST principles · auth flows (OAuth / Bearer / API Key / Basic). База перед углублением в Postman.',
    estimateMin: 140,
    ticketIds: ['API-01', 'API-02', 'API-03', 'API-04', 'API-05', 'API-06', 'API-07', 'API-08', 'API-09', 'API-10'],
    finalTestBankId: 'sprint-09',
    istqb: ['CTFL-Ch4'],
  },
  // S10 · Postman MASTER + SoapUI (canonical 7 MAY · MASTER скилл per skills_taxonomy · ticketIds wire в 3.4b)
  {
    id: 'S10',
    ord: 10,
    block: 'technical',
    category: 'Postman',
    title: 'Postman MASTER + SoapUI',
    goal:
      'Полноценный Postman (Collections · Environments · pm.test · Pre-request · Data-driven · Newman+CI/CD bridge) + SoapUI co-primary для cross-tool fluency.',
    estimateMin: 165,
    ticketIds: ['POST-01', 'POST-02', 'POST-03', 'POST-04', 'POST-05', 'POST-06', 'POST-07', 'POST-08', 'POST-09', 'POST-10'],
    finalTestBankId: 'sprint-10',
    istqb: ['CTFL-Ch6'],
    master: true,
  },
  // S11 · SQL Deep + DB (canonical 7 MAY · writer slot sealed S11 markdown 7 MAY · ticketIds wire в 3.4b)
  {
    id: 'S11',
    ord: 11,
    block: 'technical',
    category: 'SQL Deep',
    title: 'SQL deep + DB — глубже в данные',
    goal:
      'Subqueries · window functions · ER-диаграммы · NoSQL базово (MongoDB-toy) · генерация тестовых данных (Faker / Mockaroo).',
    estimateMin: 130,
    ticketIds: ['SQL-D1', 'SQL-D2', 'SQL-D3', 'SQL-D4', 'SQL-D5', 'SQL-D6', 'SQL-D7', 'SQL-D8', 'SQL-D9', 'SQL-D10'],
    finalTestBankId: 'sprint-11',
    istqb: [],
  },
  // S12 · Performance + Security (canonical 7 MAY · writer slot S12 reopen pending · ticketIds wire в 3.4b)
  {
    id: 'S12',
    ord: 12,
    block: 'technical',
    category: 'Performance & Security',
    title: 'Performance + Security',
    goal:
      'DevTools deep (Lighthouse · network/render/memory perf) · OWASP Top 10 (XSS / CSRF / IDOR / weak auth) · a11y deep audit · Master Test Strategy.',
    estimateMin: 150,
    ticketIds: ['NF-01', 'NF-02', 'NF-03', 'NF-04', 'NF-05', 'NF-06', 'NF-07', 'NF-08', 'NF-09', 'NF-10'],
    finalTestBankId: 'sprint-12',
    istqb: ['CTFL-Ch2', 'CTFL-Ch5'],
  },
  // ── Ренумерация Block 3 (HANDOFF_APP_SPRINT_META): мобильный спринт вставлен как
  // S13 (финал Block 2 · technical), автоматизация сдвинута к S14-S17, выпуск S18-S19.
  // Контент — 02_CONTENT/sprint_13..19_content.md. Коды тикетов реальные (code: из sprint_NN).
  // Автоматизация/карьера вне CTFL → istqb пуст. (S18 финальный проект = отдельный capstone,
  // открывается из AIM-MISSION, в ticketIds не входит.)
  {
    id: 'S13',
    ord: 13,
    block: 'technical',
    category: 'Mobile Testing',
    title: 'Мобильное тестирование — попробовать руками',
    goal:
      'Taster-минимум ручного мобильного: чем телефон ≠ веб · типы приложений · фрагментация · мобайл-условия (жесты/прерывания/сеть/разрешения/lifecycle) · эмуляторы vs устройства · мобильный баг-репорт. Практика — DevTools device-mode. Appium только awareness.',
    estimateMin: 150,
    ticketIds: ['MOB-01', 'MOB-02', 'MOB-03', 'MOB-04', 'MOB-05', 'MOB-06', 'MOB-07', 'MOB-08', 'MOB-AI', 'MOB-MISSION'],
    finalTestBankId: 'sprint-13',
    istqb: [],
  },
  {
    id: 'S14',
    ord: 14,
    block: 'automation',
    category: 'Automation Basics',
    title: 'Первые шаги в автоматизации · Playwright + минимум Python',
    goal:
      'Taster: первый автотест. Минимум Python → Playwright (локаторы get_by_role/text/label, click/fill/expect, auto-waiting). AI вшит: AI пишет — ты проверяешь.',
    estimateMin: 178,
    ticketIds: ['AUT-01', 'PY-01', 'PY-02', 'PW-01', 'PW-02', 'AI-01', 'PW-03', 'PW-04', 'AI-02', 'AI-03', 'AUT-MISSION'],
    finalTestBankId: 'sprint-14',
    istqb: [],
  },
  {
    id: 'S15',
    ord: 15,
    block: 'automation',
    category: 'Playwright + POM',
    title: 'Playwright аккуратнее · pytest, фикстуры, Page Object',
    goal:
      'pytest · фикстура page · ООП-минимум · лёгкий Page Object · параметризация · Codegen · скрин/видео при падении. 3 AI-тикета.',
    estimateMin: 180,
    ticketIds: ['STR-01', 'STR-02', 'STR-03', 'STR-04', 'STR-05', 'AI-01', 'STR-06', 'AI-02', 'STR-07', 'AI-03', 'STR-MISSION'],
    finalTestBankId: 'sprint-15',
    istqb: [],
  },
  {
    id: 'S16',
    ord: 16,
    block: 'automation',
    category: 'Selenium',
    title: 'Selenium — второй инструмент + как выбрать',
    goal:
      'WebDriver · By.* · WebDriverWait (ожидания руками) · Selenium IDE · чтение legacy · матрица Selenium↔Playwright + рынок RU/CIS. Appium-мост (T08). 3 AI-тикета.',
    estimateMin: 170,
    ticketIds: ['SEL-01', 'SEL-02', 'SEL-03', 'SEL-04', 'AI-01', 'SEL-05', 'AI-02', 'SEL-06', 'AI-03', 'SEL-MISSION'],
    finalTestBankId: 'sprint-16',
    istqb: [],
  },
  {
    id: 'S17',
    ord: 17,
    block: 'automation',
    category: 'CI/CD',
    title: 'CI/CD — тесты гоняются сами',
    goal:
      'GitHub Actions · pipeline · первый workflow · чтение прогона · артефакты · parallel/matrix · Allure/cron. Taster, БЕЗ Docker (вне курса). 2 AI-тикета.',
    estimateMin: 150,
    ticketIds: ['CI-01', 'CI-02', 'CI-03', 'CI-04', 'AI-01', 'CI-05', 'CI-06', 'AI-02', 'CI-MISSION'],
    finalTestBankId: 'sprint-17',
    istqb: [],
  },
  {
    id: 'S18',
    ord: 18,
    block: 'graduation',
    category: 'AI Mastery',
    title: 'AI Mastery для QA + финальный проект',
    goal:
      'DEEP AI: prompt-engineering · AI-генерация тест-кейсов · visual testing · AI-триаж/scorer/mentor · пределы/риски/этика AI. + финальный проект (отдельный capstone-артефакт).',
    estimateMin: 200,
    ticketIds: ['AIM-01', 'AIM-02', 'AIM-03', 'AIM-04', 'AIM-05', 'AIM-06', 'AIM-07', 'AIM-08', 'AIM-09', 'AIM-MISSION'],
    finalTestBankId: 'sprint-18',
    istqb: [],
    master: true,
  },
  {
    id: 'S19',
    ord: 19,
    block: 'graduation',
    category: 'Career Launch',
    title: 'Career Launch',
    goal:
      'Резюме · портфолио · LinkedIn · банк вопросов собеса 50+ · mock interview · ISTQB где сдать · что учить дальше. Карьерный, без code-along.',
    estimateMin: 130,
    ticketIds: ['CAR-01', 'CAR-02', 'CAR-03', 'CAR-04', 'CAR-05', 'CAR-06', 'AI-01', 'CAR-07', 'CAR-08', 'CAR-MISSION'],
    finalTestBankId: 'sprint-19',
    istqb: [],
    examSprint: true,
    release: 'v2.0',
  },
];

export const sprintById = (id: string): Sprint | undefined => SPRINTS.find((s) => s.id === id);
